import { ApolloClient, gql, TypedDocumentNode } from '@apollo/client'
import type {
  CreateWorkPostSheetMutation,
  CreateWorkPostSheetMutationVariables
} from './__generated__/CreateWorkPostSheetMutation'
import { workPostSheetFragment } from '../fragments/WorkPostSheetFragment'

const mutation: TypedDocumentNode<
  CreateWorkPostSheetMutation,
  CreateWorkPostSheetMutationVariables
> = gql`
  ${workPostSheetFragment}

  mutation CreateWorkPostSheetMutation($input: CreateWorkPostSheetInput!) {
    createWorkPostSheet(input: $input) {
      workPostSheet {
        ...WorkPostSheetFragment
        position {
          id
          workPostSheet {
            ...WorkPostSheetFragment
          }
        }
      }
    }
  }
`

export function createWorkPostSheetMutation(
  apolloClient: ApolloClient,
  options: Omit<
    ApolloClient.MutateOptions<
      CreateWorkPostSheetMutation,
      CreateWorkPostSheetMutationVariables
    >,
    'mutation'
  >
) {
  return apolloClient.mutate({
    mutation,
    ...options
  })
}
